/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';

export const ICON_ROUTE_WITH_CANCEL = (
  <svg fill="none" height="176" viewBox="0 0 177 176" width="177" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 88C0.5 39.3989 39.8989 0 88.5 0C137.101 0 176.5 39.3989 176.5 88V144C176.5 161.673 162.173 176 144.5 176H88.5C39.8989 176 0.5 136.601 0.5 88Z"
      fill="#F5F5F5"
    />
    <rect fill="#057E91" height="120" rx="60" width="120" x="28" y="24" />
    <path
      d="M107.6 92.9038V69.9998C107.6 63.8118 102.588 58.7998 96.3998 58.7998C90.2118 58.7998 85.1998 63.8118 85.1998 69.9998V97.9998C85.1998 101.08 82.6798 103.6 79.5998 103.6C76.5198 103.6 73.9998 101.08 73.9998 97.9998V75.0958C77.2478 73.9198 79.5998 70.8398 79.5998 67.1998C79.5998 62.5518 75.8478 58.7998 71.1998 58.7998C66.5518 58.7998 62.7998 62.5518 62.7998 67.1998C62.7998 70.8398 65.1518 73.9198 68.3998 75.0958V97.9998C68.3998 104.188 73.4118 109.2 79.5998 109.2C85.7878 109.2 90.7998 104.188 90.7998 97.9998V69.9998C90.7998 66.9198 93.3198 64.3998 96.3998 64.3998C99.4798 64.3998 102 66.9198 102 69.9998V92.9038C98.7518 94.0518 96.3998 97.1318 96.3998 100.8C96.3998 105.448 100.152 109.2 104.8 109.2C109.448 109.2 113.2 105.448 113.2 100.8C113.2 97.1598 110.848 94.0798 107.6 92.9038Z"
      fill="white"
    />
    <g clipPath="url(#clip0_1994_11146)">
      <circle cx="132.5" cy="132" fill="#F5F5F5" r="29" />
      <rect fill="#BABABA" height="48" rx="24" width="48" x="108" y="108" />
      <rect fill="white" height="20" rx="10" width="20" x="122" y="122" />
      <path
        d="M132 115.333C122.783 115.333 115.333 122.783 115.333 132C115.333 141.216 122.783 148.666 132 148.666C141.216 148.666 148.666 141.216 148.666 132C148.666 122.783 141.216 115.333 132 115.333ZM139.166 139.166C138.516 139.816 137.466 139.816 136.816 139.166L132 134.35L127.183 139.166C126.533 139.816 125.483 139.816 124.833 139.166C124.183 138.516 124.183 137.466 124.833 136.816L129.65 132L124.833 127.183C124.183 126.533 124.183 125.483 124.833 124.833C125.483 124.183 126.533 124.183 127.183 124.833L132 129.65L136.816 124.833C137.466 124.183 138.516 124.183 139.166 124.833C139.816 125.483 139.816 126.533 139.166 127.183L134.35 132L139.166 136.816C139.8 137.45 139.8 138.516 139.166 139.166Z"
        fill="#BABABA"
      />
    </g>
    <defs>
      <clipPath id="clip0_1994_11146">
        <rect fill="white" height="58" transform="translate(103.5 103)" width="58" />
      </clipPath>
    </defs>
  </svg>
);
